/*
 * @message:
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2022-01-06 17:28:35
 * @FilePath: \mrc-base-frontend\src\service\api\pushMessageLogs.js
 * @最后编辑: Betway
 * @最后修改时间: 2022-01-07 16:42:28
 */
// 消息模板
import http from "../httpConfig";

const table = "mrbase_sys_message_push_log";
const table_detail = "mrbase_sys_message_push_log_detail";

// 获取列表
export const getMessageLogsList = (params = {}) => {
  params["~table~"] = table;
  return new Promise((resolve, reject) => {
    http
      .post("/api/message/push/get-log-list/v1", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 获取详情
export const getMessageLogsDetail = (params = {}) => {
  params["~table~"] = table;
  return new Promise((resolve, reject) => {
    http
      .post("/api/message/push/get-log/v1", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
// 获取详细日志列表
export const getMessageLogsDetailList = (params = {}) => {
  params["~table~"] = table_detail;
  return new Promise((resolve, reject) => {
    http
      .post("/api/message/push/get-log-detail-list/v1", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
// 获取详细日志详情
export const getMessageLogsDetailDetail = (params = {}) => {
  params["~table~"] = table_detail;
  return new Promise((resolve, reject) => {
    http
      .post("/api/message/push/get-log-detail/v1", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
